import { useEffect, useState } from 'react';
import api from '../../services/api';
import PMModal from './PMModal';
import { II } from '../../components/common/Icons';import "../../assets/styles/PM/PMHrRequestsPg.css";

const formatDateOnly = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

const getLifecycleStatusMeta = (status) => {
  const key = String(status || '').toLowerCase();
  const map = {
    pending_pm: { label: 'Pending PM', chip: 'chip-ip' },
    pending_hr: { label: 'Pending HR', chip: 'chip-ip' },
    approved_pm: { label: 'Approved PM', chip: 'chip-ok' },
    approved_hr: { label: 'Approved HR', chip: 'chip-ok' },
    rejected_pm: { label: 'Rejected PM', chip: 'chip-dn' },
    rejected_hr: { label: 'Rejected HR', chip: 'chip-dn' },
    resend_hr: { label: 'Resend To HR', chip: 'chip-wn' },
    resend_employee: { label: 'Resend To Employee', chip: 'chip-wn' },
    pm_scheduled: { label: 'PM Scheduled', chip: 'chip-wn' },
    notice_period: { label: 'Notice Period', chip: 'chip-wn' },
    awaiting_employee_form: { label: 'Awaiting Employee Form', chip: 'chip-wn' },
    pending_it: { label: 'Pending IT', chip: 'chip-wn' },
    it_replied: { label: 'IT Replied', chip: 'chip-wn' },
    hr_docs_uploaded: { label: 'HR Docs Uploaded', chip: 'chip-wn' },
    settlement_pending_pm: { label: 'Settlement Pending PM', chip: 'chip-wn' },
    settlement_rework_hr: { label: 'Settlement Rework HR', chip: 'chip-dn' },
    settlement_approved_pm: { label: 'Settlement Approved PM', chip: 'chip-ok' },
    settlement_sent: { label: 'Settlement Sent', chip: 'chip-ok' }
  };
  return map[key] || { label: status || '-', chip: 'chip-wn' };
};

function PMHrRequestsPg() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);
  const [logs, setLogs] = useState([]);
  const [comment, setComment] = useState('');
  const [meetingTime, setMeetingTime] = useState('');
  const [toast, setToast] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const data = await api.getPMHrRequests();
      setRows(Array.isArray(data) ? data : []);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {load();}, []);

  const openReq = async (r) => {
    setActive(r);
    setComment('');
    setMeetingTime(r.meeting_time || '');
    const l = await api.getLifecycleLogs(r.req_id).catch(() => []);
    setLogs(Array.isArray(l) ? l : []);
  };

  const action = async (a) => {
    if (!active?.req_id) return;
    if ((a === 'reject' || a === 'resend_hr' || a === 'resend_employee') && !String(comment || '').trim()) {
      setToast('Comment is required for reject/resend.');
      setTimeout(() => setToast(''), 2500);
      return;
    }
    try {
      await api.pmHrRequestAction({ reqId: active.req_id, action: a, comment, meetingTime });
      setToast(`Request ${a}`);
      setTimeout(() => setToast(''), 2500);
      setActive(null);
      await load();
    } catch (e) {
      setToast(e.message || 'Action failed');
      setTimeout(() => setToast(''), 2500);
    }
  };

  return (
    <div>
      <div className="sec">HR Requests</div>
      {toast && <div className="toast">{toast}</div>}
      <div className="cd">
        <div className="cd-h">
          <div className="cd-t">Onboarding & Offboarding Requests</div>
          <div className="cd-s">{rows.length} records</div>
        </div>
        <div className="cd-b pmhrrequestspg-inline-1">
          {loading ? <div className="pmhrrequestspg-inline-2">Loading...</div> :
          <table className="tbl">
              <thead>
                <tr>
                  <th>Req ID</th><th>Type</th><th>Title</th><th>Employee</th><th>Status</th><th>File</th><th>Sign</th><th>Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ?
              <tr><td colSpan="8" className="pmhrrequestspg-inline-3">No HR requests</td></tr> :
              rows.map((r) =>
              <tr key={r.req_id}>
                    <td className="pmhrrequestspg-inline-4">{r.req_id}</td>
                    <td>{r.request_type}</td>
                    <td className="pmhrrequestspg-inline-5">{r.title || '-'}</td>
                    <td>{r.user_name || '-'}</td>
                    <td><span className={`chip ${getLifecycleStatusMeta(r.status).chip}`}>{getLifecycleStatusMeta(r.status).label}</span></td>
                    <td>{r.file_url ? <button className="btn-o btn-s" onClick={() => api.downloadFile(r.file_url, r.file_name || 'request-file')}>{II('download', 11)} Download</button> : '-'}</td>
                    <td>{r.signature_url ? <button className="btn-o btn-s" onClick={() => api.downloadFile(r.signature_url, r.signature_name || 'signature-file')}>{II('eye', 11)} View</button> : '-'}</td>
                    <td><button className="btn-o btn-s" onClick={() => openReq(r)}>{II('eye', 11)} Review</button></td>
                  </tr>
              )}
              </tbody>
            </table>
          }
        </div>
      </div>

      <PMModal open={!!active} onClose={() => setActive(null)} title={`Request ${active?.req_id || ''}`} wide>
        {active &&
        <div>
            <div className="pmhrrequestspg-inline-6">
              <b>Type:</b> {active.request_type} | <b>Status:</b> {getLifecycleStatusMeta(active.status).label}
            </div>
            <div className="pmhrrequestspg-inline-7">
              {active.file_url ? <button className="btn-o btn-s" onClick={() => api.downloadFile(active.file_url, active.file_name || 'request-file')}>View File</button> : null}
              {active.signature_url ? <button className="btn-o btn-s" onClick={() => api.downloadFile(active.signature_url, active.signature_name || 'signature-file')}>View Signature</button> : null}
            </div>
            <textarea className="fta" rows={3} placeholder="Comment" value={comment} onChange={(e) => setComment(e.target.value)} />
            {active.request_type === 'offboarding' &&
          <input className="fi pmhrrequestspg-inline-8" placeholder="Meeting Time (for resend to employee)" value={meetingTime} onChange={(e) => setMeetingTime(e.target.value)} />
          }
            <div className="pmhrrequestspg-inline-9">
              <button className="btn btn-ok" onClick={() => action('approve')}>Approve</button>
              <button className="btn btn-dn" onClick={() => action('reject')}>Reject</button>
              <button className="btn pmhrrequestspg-inline-10" onClick={() => action('resend_hr')}>Resend HR</button>
              {active.request_type === 'offboarding' &&
            <button className="btn pmhrrequestspg-inline-11" onClick={() => action('resend_employee')}>Resend Employee</button>
            }
            </div>
            <div className="pmhrrequestspg-inline-12">
              <div className="pmhrrequestspg-inline-13">Logs</div>
              {logs.length === 0 ? <div className="pmhrrequestspg-inline-14">No logs</div> : logs.map((l) =>
            <div key={l.id} className="pmhrrequestspg-inline-15">
                  <div className="pmhrrequestspg-inline-16">{l.action}</div>
                  <div className="pmhrrequestspg-inline-17">{l.comment || '-'}</div>
                  <div className="pmhrrequestspg-inline-17">{formatDateOnly(l.created_at)}</div>
                </div>
            )}
            </div>
          </div>
        }
      </PMModal>
    </div>);

}

export default PMHrRequestsPg;
